export default __webpack_public_path__ + "d4dd9c6d80f3e4b311de161ff05f0925.png";